import { render, staticRenderFns } from "./MasterDataForm.vue?vue&type=template&id=9c719584&"
import script from "./MasterDataForm.vue?vue&type=script&lang=js&"
export * from "./MasterDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MasterDataForm.vue"
export default component.exports